import React from 'react'
import { Helmet } from 'react-helmet'
import styled, { ThemeProvider } from 'styled-components'

import Footer from 'src/components/Footer'
import Navbar from 'src/components/Navbar'
import GlobalStyle from 'src/components/Layout/GlobalStyle'

import 'src/css/global.css'

import favicon from 'src/assets/img/logos/favicon.ico'

const colors = {
  // Branded
  navy: '#161345',
  pink: '#FFCFDB',
  peach: '#FFDFD7',
  orange: '#FF7F00',
  teal: '#60C4BF',
  slate: '#999999',
  lightGrey: '#E5E5E5',
  lightText: '#EBEBEB',
  // Unbranded
  white: '#FFFFFF',
  black: '#0A0A0A',
  success: '#37b635',
  warning: '#ec1818',
}

const fonts = {
  athletics: {
    medium: 'Athletics-Medium, Roboto, Helvetica Neue, Arial, sans-serif',
  },
  larsseit: {
    normal: 'Larsseit, Roboto, Helvetica Neue, Arial, sans-serif',
    regular: 'Larsseit-Regular, Roboto, Helvetica Neue, Arial, sans-serif',
    bold: 'Larsseit-Bold, Roboto, Helvetica Neue, Arial, sans-serif',
    medium: 'Larsseit-Medium, Roboto, Helvetica Neue, Arial, sans-serif',
    light: 'Larsseit-Light, Roboto, Helvetica Neue, Arial, sans-serif',
  },
  monosten: {
    normal: 'Monosten, Roboto, Helvetica Neue, Arial, sans-serif',
  },
}

const RootWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100vw;
`

const Main = styled.main`
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  z-index: 5;
`

const StyledThemeProvider = styled(ThemeProvider)`
  z-index: 5;
`

const Layout = ({ children, location }) => {
  return (
    <RootWrapper>
      <Helmet
        htmlAttributes={{ lang: 'en' }}
        link={[{ rel: 'icon', type: 'image/png', href: favicon }]}
      />
      <GlobalStyle />
      <StyledThemeProvider theme={{ colors, fonts }}>
        <Navbar location={location} />
        <Main>{children}</Main>
        <Footer />
      </StyledThemeProvider>
    </RootWrapper>
  )
}

export default Layout
